export default class AlgonomyCookieStringStorage {
  private static ALGONOMY_COOKIE_STRING_STORAGE_KEY: "reco_recommendations_frontend_algonomy_cookie_string" =
    "reco_recommendations_frontend_algonomy_cookie_string" as const;
  static retrieve(): string | null {
    try {
      return localStorage.getItem(
        AlgonomyCookieStringStorage.ALGONOMY_COOKIE_STRING_STORAGE_KEY,
      );
    } catch (_) {
      return null;
    }
  }

  static store(algonomyCookieString: string): void {
    try {
      localStorage.setItem(
        AlgonomyCookieStringStorage.ALGONOMY_COOKIE_STRING_STORAGE_KEY,
        algonomyCookieString,
      );
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }
}
